import {getAxios, getEndpointBase} from "./base.api";
import * as querystring from "../utils/querystring";
import {getLanguageCode} from "../../selectors/generic";
import {SAPProductDetail} from "../../interfaces/ecom/schema";

const ENDPOINT = "SAPProductsDetail";

const axios = getAxios();

export async function getSAPProductDetails(materialNumbers: string[]): Promise<SAPProductDetail[]> {
    const countryLanguage = getLanguageCode();
    const apiUrl = getEndpointBase(ENDPOINT);
    const body = materialNumbers;

    const queryString = querystring.stringify({
        locale: countryLanguage,
    });

    try {
        const response = await axios.post(`${apiUrl}?${queryString}`, body, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.status >= 200 && response.status < 300) {
            return response.data;
        } else {
            console.error('Error:', response.status, response.data);
            throw new Error(`Error: ${response.status}`);
        }
    } catch (error) {
        console.error(`API Endpoint error: ${error}`);
        throw error;
    }
}

